export enum CaptureType {
	IMAGE = 'image',
	VIDEO = 'video',
}
